import * as Yup from 'yup';

import { LitigationAction } from '../types';

export const litigationSchema = (
  litigationAction: LitigationAction | null,
  isFlag: boolean
) =>
  Yup.object({
    ...(isFlag && {
      reason: Yup.string().required(
        'Please select a reason before proceeding.'
      ),
    }),
    details: Yup.string().when('reason', {
      is: (reason: string) => reason === 'other',
      then: (schema) =>
        schema.required('Please provide a comment before proceeding'),
      otherwise: (schema) => schema,
    }),
    ...(litigationAction === 'FLAG' && {
      exported: Yup.boolean().oneOf(
        [true],
        'You must export the shipment data before flagging the shipment as litigation.*'
      ),
    }),
  });
